import { render } from "./ShowCustomer.vue?vue&type=template&id=d82acfe8"
import script from "./ShowCustomer.vue?vue&type=script&lang=js"
export * from "./ShowCustomer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__